<ng-container *ngIf="!content && specificContent !== null" [ngSwitch]="size">
  <ui-empty *ngSwitchCase="'normal'" class="ant-empty-normal" [uiNotFoundImage]="'simple'"></ui-empty>
  <ui-empty *ngSwitchCase="'small'" class="ant-empty-small" [uiNotFoundImage]="'simple'"></ui-empty>
  <ui-empty *ngSwitchDefault></ui-empty>
</ng-container>
<ng-container *ngIf="content">
  <ng-template *ngIf="contentType !== 'string'" [cdkPortalOutlet]="contentPortal"></ng-template>
  <ng-container *ngIf="contentType === 'string'">
    {{ content }}
  </ng-container>
</ng-container>
